<!-- 添加库存采购单 -->
<template>
<el-dialog :title="title" :visible.sync="visible" :fullscreen="isMinScreen" 
    :close-on-click-modal="false" 
    :lose-on-press-escape="false" :append-to-body="true"
    width="700px"
>
    <el-form v-if="visible" label-width="100px">
        <el-row type="flex" justify="start" style="flex-wrap: wrap;">
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('采购单号')" label-width="100px" >
                    <el-input :readonly="!isEditCode" v-model="inventoryIn.purchaseCode" placeholder="请输入采购单号" size="small"></el-input>
                </el-form-item>
            </el-col>
            <el-col :md="24" :lg="12" :xl="8">
                <el-form-item :label="msg('采购平台')" label-width="100px" >
                    <el-select v-model="inventoryIn.origin" filterable  :placeholder="msg('请选择')" size="mini">
                        <el-option v-for="item in dicts.productOrigin" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :md="24" :lg="12" :xl="8">
                <el-form-item :label="msg('到货仓库')" label-width="100px" >
                    <el-select v-model="inventoryIn.storeName" @change="selectStore" :placeholder="msg('请选择')" size="mini">
                        <el-option v-for="store in stores" :key="store.id" :label="store.name" :value="store"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('快递单号')" label-width="100px" >
                    <el-input :readonly="!isEditCode"  v-model="inventoryIn.expCode" placeholder="请输入快递单号" size="small">
                        <template v-if="isAdd" slot="append">
                            <el-checkbox v-model="resetOwner">认领</el-checkbox>
                        </template>
                    </el-input>
                    <div  v-if="isAdd" style="color: #ff8d8d; line-height: 120%; font-size:12px;">单号已存在，如查询不到，可勾选认领！</div>
                </el-form-item>
            </el-col>
            <el-col :md="24" :lg="12" :xl="8">
                <el-form-item :label="msg('件数')">
                    <el-input-number v-model="inventoryIn.qty" :min="1" size="mini"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :md="24" :lg="12" :xl="8" >
                <el-form-item :label="msg('采购金额')">
                    <el-input-number v-model="inventoryIn.price" :min="0" size="mini"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :md="24" :lg="12" :xl="8">
                <el-form-item :label="msg('归属人')" label-width="100px" >
                    <el-autocomplete size="mini" clearable 
                        v-model="inventoryIn.ownerName"
                        :fetch-suggestions="searchUser"
                        :highlight-first-item="true"
                        :placeholder="this.msg('搜索归属人')"
                        :trigger-on-focus="false"
                        @select="selectUser"
                        @clear="clearUsername"
                        ref="userRef"
                    ></el-autocomplete>
                </el-form-item>
            </el-col>
            <el-col :md="24" :lg="12" :xl="8">
                <el-form-item :label="msg('补货单号')" label-width="100px" >
                    <el-input v-model="inventoryIn.inCode" placeholder="请输入库存单号" size="small"></el-input>
                    <div style="color: #ff8d8d; line-height: 120%; font-size:12px;">上架后只增加相应的库存数量，对应的库存单号必须存在</div>
                </el-form-item>
            </el-col>
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('采购链接')" label-width="100px" >
                    <el-input v-model="inventoryIn.link" @keyup.native="enterInputLink" placeholder="请输入采购链接" size="small"  maxlength="100" show-word-limit></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('备注')" label-width="100px" >
                    <el-input v-model="inventoryIn.remark" @keyup.native="enterInputLink" placeholder="请输入备注" size="small"  maxlength="64" show-word-limit></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('SKU')" label-width="100px" >
                    <el-input v-model="inventoryIn.sku" placeholder="请输入SKU" size="small"  maxlength="64" show-word-limit></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('货号')" label-width="100px" >
                    <el-input v-model="inventoryIn.variationSku" placeholder="请输入货号" size="small"  maxlength="64" show-word-limit></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('规格')" label-width="100px" >
                    <el-input v-model="inventoryIn.spec" placeholder="请输入规格" size="small"  maxlength="100" show-word-limit></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="24" :xl="12">
                <el-form-item :label="msg('产品名')" label-width="100px" >
                    <el-input v-model="inventoryIn.title" placeholder="请输入产品名" size="small"  maxlength="100" show-word-limit></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <div style="text-align:center; margin-top: 15px;">
            <el-button size="mini"  @click="close(false)"><i class="el-icon-close"></i><span>{{msg('取消')}}</span></el-button>
            <el-button type="primary" size="mini"  @click="onSubmit()"><i class="el-icon-check"></i><span>{{submitTxt}}</span></el-button>
        </div>
    </el-form>
</el-dialog>
</template>
<script>
export default {
    name: "InventoryInAdd",
    data(){
        return {
            visible: false,
            inventoryIn: {
                purchaseCode: null, //采购单号
                storeId: null,      //到货仓库
                storeName: null,    //
                owner: null,        //归属人
                ownerName: null,     //归属人账号
                qty: 1,  //件数
                price: 0, //采购金额
                origin: null, //采购平台
                expCode: null, //快递单号
                inCode:  null,  //补库存入仓码
                sku: null, 
                variationSku: null, //货号
                spec: null, //规格
                title: null, //产品名
                link: null, //链接
            }, 
            resetOwner: false,  //认领，重设已存在快递单号的归属人
            origins: ["淘宝", "拼多多", "1688" , "其他"],
            stores: null,
            title: null,
            submitTxt: null,
            isAdd: true,
            isEditCode: true,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        }
    },
    methods: {
        //type : 1-新增，2-更新
        async showDialog(type, inv, stores){
            
            this.isAdd = type == 1?true:false;
            this.isEditCode = true;
            this.resetOwner = false;

            if(stores && stores.length>0){
                this.stores = stores;
            }else{
                let result = await this.$axios.post(this.$kit.api.store.listUsed, {});
                if(result.status){
                    let data = result.data;
                    data.splice(0, 0, {id: 0, name: '默认仓库'});
                    this.stores = data;
                }else{
                    this.stores = [{id: 0, name: '默认仓库'}];
                }
            }

            if(type == 1){
                this.title = "添加库存采购单";
                this.submitTxt = "确定新增";

                let row =  {
                    purchaseCode: null, //采购单号
                    storeId: null,      //到货仓库
                    owner: null,        //归属人
                    ownerName: null,     //归属人账号
                    qty: 1,  //件数
                    price: 0, //采购金额
                    origin: null, //采购平台
                    expCode: null, //快递单号
                    inCode:  null,  //补库存入仓码
                    sku: null, 
                    variationSku: null, //货号
                    spec: null, //规格
                    title: null, //产品名
                    link: null,
                };

                this.inventoryIn = {...row, ...inv};
                this.inventoryIn.id = null;
                this.inventoryIn.expCode = null;
                this.inventoryIn.receiveDate = null;
                this.inventoryIn.status = null;
                this.inventoryIn.inCode = null;
                this.inventoryIn.price = (this.inventoryIn.price||0) * 0.01;

            }else{
                this.title = "编辑库存采购单";
                this.submitTxt = "确定更新";
                this.inventoryIn = {...inv};
                this.inventoryIn.price = this.inventoryIn.price * 0.01;
                 //已签收后，有些字段不能编辑
                 if(this.inventoryIn.status >= 15){
                    this.isEditCode = false;
                }
            }

            this.visible = true;

        },
        searchUser(queryString, cbFn){  //搜索用户
            this.$axios.get(this.$kit.api.user.search
                +"?name="+encodeURIComponent(queryString)+"&type=1"
            ).then((result) => {
                if(result.status){
                    let users =[];
                    result.data.forEach(e => {
                        users.push({
                            id: e.id,
                            value: e.value
                        });
                    });
                    cbFn(users);
                }
            });
        },
        selectUser(item) { //获取选中的用户
            this.inventoryIn.owner = item.id;
            this.inventoryIn.ownerName = item.value;
        },
        selectStore(item){
            this.inventoryIn.storeId = item.id;
            this.inventoryIn.storeName = item.name;
        },
        clearUsername(){
            this.inventoryIn.ownerName = null;
            this.inventoryIn.owner = null;
        },
        enterInputLink(event){
            if (event.keyCode === 13) {
                let link = this.inventoryIn.link;
                console.log(link);
                if(link.indexOf("yangkeduo.com") != -1 || link.indexOf("pinduoduo.com") != -1){
                    this.inventoryIn.origin = "拼多多";
                }else if(link.indexOf("tmall.com") != -1 || link.indexOf("taobao.com") != -1){
                    this.inventoryIn.origin = "淘宝";
                }else if(link.indexOf("1688.com") != -1){
                    this.inventoryIn.origin = "1688";
                }
            }

           
        },
        onSubmit(){

            let inv = {...this.inventoryIn};

            inv.price = (inv.price || 0)*100;

            delete inv.storeType;
            delete inv._XID;

            let url = this.isAdd?
                this.$kit.api.inventoryIn.create
                :this.$kit.api.inventoryIn.update
            
            this.$axios.post(url+
                "?resetOwner="+(this.resetOwner?1:0), 
                inv
            ).then((result) => {
                this.$message(result.msg);
                if(result.status){
                    this.close(true);
                }
            });
        },
        close(refresh){
            this.visible = false;
            if(refresh){
                this.$emit("finish");
            }
        }
    }
}

</script>
<style></style>